module.exports = __webpack_public_path__ + "img/13.73c26a5b.jpg";